// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"0dfad621","787":"4d2e7942"}[chunkId] + ".chunk.js";
};